import { Component, OnInit, OnDestroy, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { ReportDto } from 'src/app/dtos/report-dto-model';
import { ConfigService } from 'src/app/services/config.service';
import { ModeService } from 'src/app/services/mode.service';
import { Subscription } from 'rxjs';
import { ReportLogDto } from 'src/app/dtos/reportLog-dto-model';
import { service, factories, models } from 'powerbi-client';
import * as CryptoJS from 'crypto-js';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit, OnDestroy  {
  @ViewChildren('reportContainer') reportContainers!: QueryList<ElementRef>;
  private readonly _activatedRoute: ActivatedRoute;
  selectedPanel: string | null = null;
  reports: ReportDto[] | null = [new ReportDto()];
  reportLogDto = new ReportLogDto;
  configIsReadySubscription: Subscription = new Subscription();
  salesReports: any;
  revenueReports: any;
  productReports: any;
  marketingReports: any;
  financeReports:any;
  newAcctsRecvReports: any;
  isLoading: boolean = false;
  isRealTimeReport: boolean = false;
  orbitUrl = '';
  selectedWorkspaceID = '';
  selectedReportID = '';
  encryptedTokenString = '';
  private token = '';
  private embeddedReport: any = null;
  private activeWorkspaceId = '';
  private activeReportId = '';
  private tokenRefreshTimer: any = null;
  activeReportTab: string | null = null;
  private powerbiService = new service.Service(
        factories.hpmFactory,
        factories.wpmpFactory,
        factories.routerFactory
      );
  pendingReport: ReportDto | null = null;
  constructor(activatedRoute: ActivatedRoute,
    private readonly reportservice: ReportService,
    private readonly configService: ConfigService,
    public readonly modeService: ModeService
  ) {
    this._activatedRoute = activatedRoute;
  }
  async ngOnInit(): Promise<void> {
    await this.getReportsDetails();
    this.orbitUrl = this.configService.orbitUrl;
    console.log('ngOnInit called');
     let report:any;
  let workspaceId = this._activatedRoute.snapshot.params.workspaceid;
  let reportId = this._activatedRoute.snapshot.params.reportId;
  let tabename = this._activatedRoute.snapshot.params.Tabename?.toLowerCase();
  let reportform='';
if(workspaceId&&reportId){
  //setTimeout(() => {
  const selectedreport=this.salesReports?.find((r: { reportId: any; workspaceId: any; }) => r.reportId == reportId && r.workspaceId == workspaceId);
  if (selectedreport) {
    switch (tabename) { 
      case 'sales': 
      this.selectedPanel = 'salesTab'; 
      reportform = 'embedForm';
      break;
      case 'product':
      this.selectedPanel = 'productTab'; 
      reportform = 'embedFormProduct';
      break;  
      case 'revenue':
      this.selectedPanel = 'revenueTab'; 
      reportform = 'embedFormRevenue';
      break;
      case 'marketing':
      this.selectedPanel = 'marketingTab'; 
      reportform = 'embedForm';
      break;
      case 'finance':
      this.selectedPanel = 'financeTab'; 
      reportform = 'embedFormFinance';
      break;
      case 'peoplesoft':
      this.selectedPanel = 'peopleSoftTab'; 
      reportform = 'embedFormPeopleSoft';
      break;
      default:
      this.selectedPanel = 'salesTab'; 
      reportform = 'embedForm';
      break;

    }
        this.selectReport(selectedreport);
      }
  //}, 1000);
} 
  };
  ngDoCheck(){
    //console.log('ngDoCheck called');
  }
ngAfterContentInit(){
  console.log('ngAfterContentInit called');
}
ngAfterContentChecked(){
  //console.log('ngAfterContentChecked called');  
}
ngAfterViewInit(){
 console.log('ngAfterViewInit called');
}
ngAfterViewChecked()
{
  //console.log('ngAfterViewChecked called');   
}
  async getReportsDetails() {
    this.modeService.addToWaitList("Loading Reports");
    this.reports = await this.reportservice.getReports();
    this.reports = this.reports?.sort((a, b) => a.reportName.localeCompare(b.reportName)) ?? [];
    const resources: string[] = this.configService.securityUser?.resources ?? [];
    
    const filteredReports = this.reports.filter(
      r => r.resource && resources.some(res => res.toLowerCase() === r.resource.toLowerCase())
    );
  if(this.configService.securityUser?.roles.length == 0 && localStorage.getItem('IsImpersonated')){
    const role = localStorage.getItem('impersonateType');
    if (role) {
      this.configService.securityUser.roles = [role.replace(/\s+/g, '').trim()];
    }
  }
  //Role checks
  const isFinanceUser = this.hasRole(['Finance']);
  const isMarketingUser = this.hasRole(['OptumMarketingUser', 'MarketingSpecialist']);
  const isAdminOrEngineer = this.hasRole(['SystemAdministrator', 'SoftwareEngineer']);
   
   //Role-based Report Category filtering
  this.salesReports = this.byCategory(filteredReports, ['Sales']);
  this.revenueReports = this.byCategory(filteredReports, ['Revenue']);
  if(!isFinanceUser){
  this.productReports = this.byCategory(filteredReports, [
    'Product/Inventory',
    'Product/Inventory - Finance'
  ]);
}
  this.newAcctsRecvReports = this.byCategory(filteredReports, ['NewAcctsRecv']);
   
  //Role‑specific assignments
  if (isFinanceUser || isAdminOrEngineer) {
    this.financeReports = this.byCategory(filteredReports, [
      'Finance',
      'Product/Inventory - Finance'
    ]);
  }
  
  if (isMarketingUser || isAdminOrEngineer) {
    this.marketingReports = this.marketingReports = this.byCategory(filteredReports, ['Marketing']);
  }
    this.openFirstVisibleTab();
    this.modeService.removeFromWaitList("Loading Reports");
  }
 
private hasRole(allowedRoles: string[]): boolean {
  return this.configService.securityUser?.roles?.some(role =>
    allowedRoles.includes(role)
  ) ?? false;
}

private byCategory(reports: any[], categories: string[]) {
  return reports.filter(r => categories.includes(r.reportCategory));
}

openFirstVisibleTab(): void {
  const tabs = [
    { panel: 'salesTab', visible: this.salesReports?.length > 0 },
    { panel: 'productTab', visible: this.productReports?.length > 0 },
    { panel: 'revenueTab', visible: this.revenueReports?.length > 0 },
    { panel: 'marketingTab', visible: this.marketingReports?.length > 0 },
    { panel: 'financeTab', visible: this.financeReports?.length > 0 },
    { panel: 'peopleSoftTab', visible: this.newAcctsRecvReports?.length > 0 }
  ];

  const firstVisible = tabs.find(t => t.visible);
  this.selectedPanel = firstVisible ? firstVisible.panel : null;
}

  async saveReportLog(report: ReportDto){
    const logDto = {
      userName: this.configService.getLoggedInUserName(),
      userEmail: this.configService.getLoggedInUserEmail(),
      reportId: report.reportId,
      reportName: report.reportName,
      workspaceId: report.workspaceId
    };
    this.reportLogDto = logDto;
    await this.reportservice.saveReportLogs(this.reportLogDto);

  }
  selectPanel(panel: string): void {
    this.selectedPanel = panel;
  }

  async selectReport(report: ReportDto) {
    this.isLoading = true;
    this.activeReportTab = null; // hide container until embed is ready
    const pendingTab = this.selectedPanel;
    const container = document.getElementById('reportContainer');
    if (container) {
      this.powerbiService.reset(container);
    }

    const isRealTime = report.reportName.toLowerCase().includes('real time stats');
    this.isRealTimeReport = isRealTime;
    if (isRealTime) {
      this.selectedWorkspaceID = report.workspaceId;
      this.selectedReportID = report.reportId;
      await this.Embed(pendingTab);
    } else {
      await this.EmbedTest(report.workspaceId, report.reportId, pendingTab);
    }
  }

  Embed(pendingTab: string | null): Promise<void> {
    return new Promise((resolve) => {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);
      this.token = currentUser.access_token;

      const iv = CryptoJS.lib.WordArray.random(16);
      const enckeyBytes = CryptoJS.enc.Utf8.parse(this.configService.powerbi_encryptionKey);
      const hmackeybytes = CryptoJS.enc.Utf8.parse(this.configService.powerbi_hmacKey);
      const ivString = CryptoJS.enc.Base64.stringify(iv);

      const encryptedToken = CryptoJS.AES.encrypt(this.token, enckeyBytes, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      const combinedstring = ivString + encryptedToken.toString();
      const hmac = CryptoJS.HmacSHA256(combinedstring, hmackeybytes);
      this.encryptedTokenString =
        CryptoJS.enc.Base64.stringify(hmac) + ':' + ivString + ':' + encryptedToken.toString();

      let attempts = 0;
      const maxAttempts = 10;
      const ready = setInterval(() => {
        const form = document.getElementById('embedFormRealTime') as HTMLFormElement;
        form?.submit();
        const iframe = document.querySelector('iframe[name="reportIframeRealTime"]') as HTMLIFrameElement;
        if (iframe && form) {
          clearInterval(ready);
          iframe.onload = () => {
            this.activeReportTab = pendingTab;
            console.log('Report iframe loaded');
            this.isLoading = false;
            resolve();
          };
          form?.submit();
        } else if (++attempts >= maxAttempts) {
          console.log('attempts',attempts);
          this.activeReportTab = pendingTab;
          clearInterval(ready);
          this.isLoading = false;
          resolve();
        }
      }, 100);
    });
  }
  private getIdpTokenType(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);
    const identityProvider: string = currentUser?.profile?.identity_provider ?? '';
    console.log('Identity Provider:', identityProvider);
    return identityProvider === 'uhg-ms-id' ? 'sentinel' : 'onehealthcareid';
  }

  async EmbedTest(workspaceId: string, reportId: string, pendingTab: string | null): Promise<void> {
    return new Promise(async (resolve) => {
      const BASE_URL = this.configService.orbitNewUrl;
      const currentUser = JSON.parse(localStorage.getItem("currentUser") as any);

      const ACCESS_TOKEN = currentUser.access_token;
      const IDP_TOKEN_TYPE = this.getIdpTokenType();

      const url =
        `${BASE_URL}/api/util/orbitportal/1.0/api/` +
        `PowerBI-Embedding/Workspaces/${workspaceId}/` +
        `Reports/${reportId}/EmbedToken`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN}`,
            "X-Idp-Token-Type-Header": IDP_TOKEN_TYPE,
          },
        });

        const data = await response.json();
        console.log("API Response:", data);

        const pbiReportId = data.embedReportData[0].reportId;
        const embedUrl = data.embedReportData[0].embedUrl;
        const embedToken = data.embedToken.token;
        const expiresIn: number = data.embedToken.expiresIn;

        const config: models.IReportEmbedConfiguration = {
          type: "report",
          id: pbiReportId,
          embedUrl: embedUrl,
          accessToken: embedToken,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: false },
            },
          },
        };

        let attempts = 0;
        const maxAttempts = 10;
        const ready = setInterval(() => {
          const container = document.getElementById("reportContainer");

          if (container) {
            clearInterval(ready);
            this.powerbiService.reset(container);
            this.embeddedReport = this.powerbiService.embed(container, config);
            this.activeWorkspaceId = workspaceId;
            this.activeReportId = reportId;
            this.activeReportTab = pendingTab;
            this.isLoading = false;
            console.log("Report embedded successfully");

            this.scheduleTokenRefresh(expiresIn);
            resolve();
          } else if (++attempts >= maxAttempts) {
            console.log("Container not found after max attempts:", attempts);
            clearInterval(ready);
            this.isLoading = false;
            resolve();
          }
        }, 100);

      } catch (error: any) {
        console.error("Error:", error.message || error);
        this.isLoading = false;
        resolve();
      }
    });
  }

  private scheduleTokenRefresh(expiresIn: number): void {
    if (this.tokenRefreshTimer) {
      clearTimeout(this.tokenRefreshTimer);
    }
    const refreshAfterMs = Math.max(0, (expiresIn - 60) * 1000);
    console.log(`Token refresh scheduled in ${refreshAfterMs / 1000}s`);
    this.tokenRefreshTimer = setTimeout(() => this.refreshEmbedToken(), refreshAfterMs);
  }

  private async refreshEmbedToken(): Promise<void> {
    if (!this.activeWorkspaceId || !this.activeReportId || !this.embeddedReport) {
      return;
    }
    console.log("Refreshing embed token silently...");
    try {
      const BASE_URL = "https://api-stg.uhg.com";
      const currentUser = JSON.parse(localStorage.getItem("currentUser") as any);
      const ACCESS_TOKEN = currentUser.access_token;

      const url =
        `${BASE_URL}/api/util/orbitportal/1.0/api/` +
        `PowerBI-Embedding/Workspaces/${this.activeWorkspaceId}/` +
        `Reports/${this.activeReportId}/EmbedToken`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${ACCESS_TOKEN}`,
          "X-Idp-Token-Type-Header": this.getIdpTokenType(),
        },
      });

      const data = await response.json();
      const newToken: string = data.embedToken.token;
      const expiresIn: number = data.embedToken.expiresIn;

      await this.embeddedReport.setAccessToken(newToken);
      console.log("Embed token refreshed silently");

      this.scheduleTokenRefresh(expiresIn);
    } catch (error: any) {
      console.error("Failed to refresh embed token:", error.message || error);
    }
  }

  ngOnDestroy(): void {
    if (this.tokenRefreshTimer) {
      clearTimeout(this.tokenRefreshTimer);
    }
  }
}
